import cx from 'classnames';
import PropTypes from 'prop-types';
import {
  FALLBACK_MOUNTAIN_IMAGE,
  SCENE7_PRESETS
} from '../../../../../constants/commonConstants';
import { productShape } from '../../../../../hooks/useAnalytics/useAnalytics.proptypes';
import ProductLink from '../../ProductLink';
import styles from './ProductCardThumbnail.module.scss';
import { ImageGrid } from 'cat-ecommerce-alloy';

const ProductCardThumbnail = ({
  alt,
  className,
  handleProductClick,
  height = '',
  imageUrl = FALLBACK_MOUNTAIN_IMAGE,
  preset = SCENE7_PRESETS.CART,
  productClickDetails,
  gaListName,
  url,
  width = '',
  children,
  specialsName,
  ...props
}) => (
  <div className="d-flex flex-column">
    <ProductLink
      className={cx(className, styles['thumbnail'])}
      handleProductClick={handleProductClick}
      link={url}
      productClickDetails={productClickDetails}
      gaListName={gaListName}
    >
      {children}
      {Array.isArray(imageUrl) ? (
        <div
          style={{ height, width }}
          data-testid="thumbnail-image-grid-wrapper"
          className="m-auto"
        >
          <ImageGrid
            images={imageUrl.map(imageData => ({
              ...imageData,
              title: alt
            }))}
          />
        </div>
      ) : (
        <img
          alt={alt}
          height={height}
          loading="lazy"
          src={`${imageUrl}?${preset}`}
          width={width}
          {...props}
        />
      )}
    </ProductLink>
    {specialsName && (
      <p
        data-testid="special-name"
        className={cx(
          styles['product-card__special-name'],
          'p-0 mb-1 text-sm-center text-uppercase fw-bold'
        )}
      >
        {specialsName}
      </p>
    )}
  </div>
);
ProductCardThumbnail.propTypes = {
  alt: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  handleProductClick: PropTypes.func,
  height: PropTypes.string,
  imageUrl: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string
      })
    )
  ]),
  preset: PropTypes.string,
  productClickDetails: PropTypes.oneOfType([
    productShape,
    PropTypes.arrayOf(productShape)
  ]),
  gaListName: PropTypes.string,
  url: PropTypes.string,
  width: PropTypes.string,
  specialsName: PropTypes.string
};

export default ProductCardThumbnail;
